import { Fragment, useState, useEffect, useContext } from 'react';
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CategoryButtonMenu, { CategoryMenu } from '../../../components/shared/CategoryButtonMenu';
import EnrollmentAnalytics from './EnrollmentAnalytics';
import EnrollmentList from './EnrollmentList';
import MultipleDropDownMenu from '../../../components/shared/MultipleDropDownMenu';
import ViewDropDownMenu from '../../../components/shared/ViewDropDownMenu';
import { EnrollmentsContext } from '../../../context/enrollment-context';
import useEnrollments from '../../../hooks/useEnrollments';
import { PageContext } from '../../../context/page-context';
import { PageFilter } from '../../../model/page';
import useStores from '../../../hooks/useStores';
import { useTranslation } from 'react-i18next';


export default function Enrollment() {
    const [category, setCategory] = useState('analytics');
    const [maskoption, setMaskOption] = useState('nomask');
    let { url } = useRouteMatch();
    const history = useHistory();
    const { categoryName }: UrlParam = useParams();
    const { data: stores } = useStores();
    const { status, data, error, isFetching } = useEnrollments();
    const [savedViews] = useState<PageFilter[]>([]);
 
    const { activeFilter, filter, setStores, setStoresFilter } = useContext(PageContext);
    const { t } = useTranslation();

    useEffect(() => {
      if (stores && setStores) {
        setStores(stores)
      }
    }, [stores, setStores]);

    useEffect(() => {
        if (categoryName === 'list') {
            setCategory('list');
        } else {
            setCategory('analytics');
        }
    }, [categoryName, setCategory]);


    interface UrlParam {
        categoryName: string;
    }

    const selectCategory = (cat: string) => {
        setCategory(cat);
        if (url === '') {
            url = '/enrollment/analytics';
        }
        history.push(`/enrollment/${cat}`);
    }

    const categories: CategoryMenu[] = [{
        name: 'analytics',
        label: t('app_analytics')
    },
    {
        name: 'list',
        label: t('app_list')
    },
    ];

    const maskOptions: CategoryMenu[] = [{
        name: 'nomask',
        label:  t('app_no_mask')
    },
    {
        name: 'mask',
        label:  t('app_mask')
    },
    ];

    return (
        <EnrollmentsContext.Provider value={{ status, data, error, isFetching,  }}>
            <Fragment>

                <Stack spacing={1}>
                    <Stack direction="row" sx={{ mb: 3 }} spacing={2}>
                        <Button color="secondary" sx={{ backgroundColor: 'text.secondary', color: 'white' }} variant="contained">
                            {t('app_save_view')}
                        </Button>
                        <ViewDropDownMenu label={t('app_saved_views')}  views={savedViews} />
                    </Stack>

                    <Stack direction="row" sx={{ mb: 3, justifyContent: 'space-between' }} spacing={5}>
                        <Stack direction="row" spacing={1} >
                            <CategoryButtonMenu category={category} selectCategory={selectCategory} categories={categories} />
                        </Stack>

                        <Stack direction="row" sx={{ justifyContent: 'flex-end' }} spacing={1} >
                            <CategoryButtonMenu category={maskoption} selectCategory={setMaskOption} categories={maskOptions} />

                            <MultipleDropDownMenu single={true} label="Level" options={['Corporate', 'District', 'Store']} />
                            <MultipleDropDownMenu label="District" options={['Socal District', 'Nocal District', 'Midwest District', 'East Coast District']} />
                            <MultipleDropDownMenu 
                                multipleLabel='Stores' 
                                label="Store" 
                                search={true} 
                                options={filter.stores && filter.stores.length > 0 ? filter.stores : stores? stores : []} 
                                selectHandler={setStoresFilter}
                                selected={activeFilter.stores}
                                />
                        </Stack>
                    </Stack>

                </Stack>

                <Grid container={true} spacing={3} sx={{ pt: 3 }}>

                    {category === 'analytics' && <EnrollmentAnalytics />}
                    {category === 'list' && <EnrollmentList />}

                </Grid>

            </Fragment>
        </EnrollmentsContext.Provider>
    )

}
